const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, 1, 125), undefined, true, false, 1));
            }

            getTemplateName() {
                return `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`;
            }

            getSourceContext() {
                return new this.Source(``, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, ``);
            }
        }],
        [125, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, 1);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['content', [this, 'block_content']],
                    ['extra', [this, 'block_extra']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -2], [`content`, `Articles`]]), false, false, 3));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>
      Sharing what we learn exploring the frontier of the web.
    </p>
  `);
            }

            block_extra(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, 14, 124), new Map([[`form_id`, `cloud-cover-test`]]), false, false, 14));
                this.echo(`  `);
            }

            getTemplateName() {
                return `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, ``);
            }
        }],
        [124, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/subscribe/subscribe.twig`, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, 14);

                this.blocks = new Map([
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/subscribe/subscribe.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            getTemplateName() {
                return `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7');

let template = env.loadTemplate('e1c4610151f00ab8a80b573ca41e0e0d377bf298b204417608f2ff8ccaf0def7');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/cloud-cover/demo/extra.twig", args: context }
     );
     return rendered;;
};